import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css';

// --- TRANSLATIONS ---
const TRANSLATIONS = {
    RU: {
        title: "EU SIGNATURE - Официальная ЭЦП",
        subtitle: "Сервис для мгновенного заверения документов электронной подписью в соответствии с директивами ЕС.",
        docData: "Данные документа",
        countryLabel: "СТРАНА ТРУДОУСТРОЙСТВА",
        countryCz: "Чешская Республика",
        countryDe: "Германия",
        contractLabel: "ПЕРСОНАЛЬНЫЙ КОД",
        clientLabel: "ФИО КЛИЕНТА",
        namePlaceholder: "Иванов Иван",
        passportLabel: "НОМЕР ПАСПОРТА",
        uploadLabel: "ТРУДОВОЙ ДОГОВОР",
        uploadPlaceholder: "Загрузите файл договора (.pdf)",
        uploadDrag: "Перетащите сюда или нажмите для выбора",
        removeFile: "Удалить файл",
        downloadSuccess: "Документ успешно подписан и скачан.",
        signButton: "ПОДПИСАТЬ",
        downloadButton: "СКАЧАТЬ ДОКУМЕНТ",
        previewTitle: "ОБРАЗЕЦ ПОДПИСИ",
        statusLabel: "Статус",
        statusReady: "ГОТОВО К ПОДПИСАНИЮ",
        infoTitle: "Юридическая сила",
        infoText: "Данная электронная подпись сгенерирована в полном соответствии с Регламентом (ЕС) № 910/2014 (eIDAS). Она обладает юридической силой, признается всеми странами-участницами Европейского Союза и обеспечивает целостность подписанного документа.",
        footerRights: "© 2026 EU Signature Gateway. Все права защищены.",
        footerPrivacy: "Политика конфиденциальности",
        footerTerms: "Условия использования",
        requiredFields: "* Все поля обязательны к заполнению",
        badges: ["Соответствует eIDAS", "Защита GDPR", "Шифрование SSL", "ISO 27001"],
        systemOnline: "СИСТЕМА В СЕТИ",
        processingPrefix: "Международная обработка",
        livePreview: "ЖИВОЙ ПРОСМОТР",
        generating: "Формирование…",
        processing: "ОБРАБОТКА…",
        regionLabel: "Регион",
        fillAllFields: "Заполните все поля",
        stampError: "Ошибка при подписании PDF",
        backHome: "← На главную",
        privacyUpdated: "Дата вступления в силу: 29 августа 2026 г.",
        termsUpdated: "Дата вступления в силу: 29 августа 2026 г.",
        privacySections: [
            { h: "1. Общие положения", p: "Настоящая Политика конфиденциальности описывает, как сервис EU SIGNATURE (сайт eusignature.com, далее — «Сервис») обрабатывает данные при заверении документов. Используя Сервис, вы подтверждаете, что ознакомились с этой Политикой." },
            { h: "2. Данные никуда не передаются", p: "Мы не продаём, не сдаём в аренду и не передаём ваши персональные данные третьим лицам, рекламным сетям, аналитическим платформам, партнёрам или иным организациям. Данные не направляются за пределы инфраструктуры Сервиса." },
            { h: "3. Какие данные обрабатываются", p: "Для формирования печати Сервис обрабатывает только те сведения, которые вы сами вводите или загружаете: имя (ФИО), номер паспорта, персональный код, выбранную страну трудоустройства и файл PDF. Дополнительно могут фиксироваться технические сведения (IP-адрес, время обращения, тип браузера) исключительно для обеспечения работоспособности и безопасности Сервиса." },
            { h: "4. Цель обработки", p: "Данные используются исключительно для генерации электронной печати, выдачи подписанного файла и показа предварительного просмотра. Иной цели обработки нет." },
            { h: "5. Хранение и удаление", p: "Загруженные PDF и сформированные файлы хранятся на сервере временно и автоматически удаляются (как правило, в течение одного часа). Мы не ведём постоянный архив ваших документов и паспортных данных." },
            { h: "6. Защита", p: "Соединение с Сервисом защищено протоколом HTTPS (SSL). Доступ к серверной инфраструктуре ограничен. Мы принимаем разумные организационные и технические меры, чтобы исключить несанкционированный доступ, утрату или раскрытие данных." },
            { h: "7. Файлы cookie", p: "Сервис не использует рекламные и аналитические cookie-файлы и не передаёт данные в системы отслеживания третьих лиц. Могут применяться только технические механизмы, необходимые для работы сайта." },
            { h: "8. Ваши права", p: "Вы можете в любой момент прекратить использование Сервиса и не загружать документы. Поскольку файлы не хранятся длительно, отдельная база «профилей пользователей» не ведётся. По вопросам обработки данных вы можете обратиться к оператору Сервиса через контакт, указанный на сайте, если он доступен." },
            { h: "9. Изменения", p: "Мы можем обновлять эту Политику. Актуальная редакция всегда публикуется на данной странице." }
        ],
        termsSections: [
            { h: "1. Принятие условий", p: "Настоящие Условия использования регулируют доступ к сервису EU SIGNATURE (eusignature.com). Пользуясь сайтом и функцией подписания документов, вы подтверждаете согласие с этими Условиями и Политикой конфиденциальности." },
            { h: "2. Описание сервиса", p: "Сервис позволяет загрузить PDF-документ, указать данные клиента и сформировать файл с электронной печатью. Сервис предоставляется через веб-интерфейс на условиях «как есть»." },
            { h: "3. Обязанности пользователя", p: "Вы подтверждаете, что имеете законное право загружать документ и указывать вводимые сведения; что данные являются корректными; и что использование Сервиса не нарушает применимое законодательство. Вы несёте ответственность за содержание загружаемых файлов." },
            { h: "4. Конфиденциальность данных", p: "Сервис не передаёт загруженные документы и введённые персональные данные третьим лицам. Обработка выполняется только для оказания услуги подписания, как описано в Политике конфиденциальности." },
            { h: "5. Доступность", p: "Мы стремимся обеспечивать бесперебойную работу, однако не гарантируем круглосуточную доступность, отсутствие технических сбоев или совместимость со всеми устройствами и браузерами." },
            { h: "6. Ограничение ответственности", p: "Сервис предоставляется без дополнительных гарантий, кроме прямо указанных в интерфейсе. В максимальной степени, допускаемой законом, оператор не несёт ответственность за убытки, возникшие вследствие неправомерного использования Сервиса, некорректных данных, действий пользователя или обстоятельств вне нашего контроля." },
            { h: "7. Запрещённое использование", p: "Запрещается использовать Сервис для целей, противоречащих закону, вмешиваться в работу инфраструктуры, пытаться получить несанкционированный доступ либо загружать вредоносные файлы." },
            { h: "8. Изменения условий", p: "Оператор вправе обновлять Условия. Продолжение использования Сервиса после публикации новой редакции означает согласие с ней." },
            { h: "9. Применимое право", p: "К настоящим Условиям применяется право Европейского Союза и применимое национальное право в той мере, в какой это следует из характера услуги и местонахождения пользователя." }
        ]
    },
    EN: {
        title: "EU SIGNATURE - Official Digital Seal",
        subtitle: "Service for immediate document certification with digital signatures in compliance with EU directives.",
        docData: "Document Data",
        countryLabel: "COUNTRY OF EMPLOYMENT",
        countryCz: "Czech Republic",
        countryDe: "Germany",
        contractLabel: "PERSONAL CODE",
        clientLabel: "CLIENT NAME",
        namePlaceholder: "John Doe",
        passportLabel: "PASSPORT NUMBER",
        uploadLabel: "LABOR CONTRACT",
        uploadPlaceholder: "Upload contract file (.pdf)",
        uploadDrag: "Drag & drop or click to select",
        removeFile: "Remove file",
        downloadSuccess: "Document successfully signed and downloaded.",
        signButton: "SIGN DOCUMENT",
        downloadButton: "DOWNLOAD DOCUMENT",
        previewTitle: "SIGNATURE PREVIEW",
        statusLabel: "Status",
        statusReady: "READY TO SIGN",
        infoTitle: "Legal Validity",
        infoText: "This digital signature is generated in full compliance with Regulation (EU) No 910/2014 (eIDAS). It holds legal validity, is recognized by all EU member states, and ensures the integrity of the signed document.",
        footerRights: "© 2026 EU Signature Gateway. All rights reserved.",
        footerPrivacy: "Privacy Policy",
        footerTerms: "Terms of Service",
        requiredFields: "* All fields are required",
        badges: ["eIDAS Compliant", "GDPR Secure", "SSL Encryption", "ISO 27001"],
        systemOnline: "SYSTEM ONLINE",
        processingPrefix: "International Processing",
        livePreview: "LIVE PREVIEW",
        generating: "Generating…",
        processing: "PROCESSING…",
        regionLabel: "Region",
        fillAllFields: "Please fill all fields",
        stampError: "Error stamping PDF",
        backHome: "← Back to home",
        privacyUpdated: "Effective date: 29 August 2026",
        termsUpdated: "Effective date: 29 August 2026",
        privacySections: [
            { h: "1. General", p: "This Privacy Policy explains how the EU SIGNATURE service (eusignature.com, the “Service”) processes data when documents are certified. By using the Service, you confirm that you have read this Policy." },
            { h: "2. We do not transfer your data", p: "We do not sell, rent or transfer your personal data to third parties, advertising networks, analytics platforms, partners or any other organisations. Data is not sent outside the Service infrastructure." },
            { h: "3. What data we process", p: "To generate a seal, the Service processes only the information you enter or upload: name, passport number, personal code, selected country of employment and the PDF file. Technical data (IP address, time of request, browser type) may be logged solely to keep the Service operational and secure." },
            { h: "4. Purpose of processing", p: "Data is used exclusively to generate the electronic seal, deliver the signed file and show a preview. There is no other processing purpose." },
            { h: "5. Storage and deletion", p: "Uploaded PDFs and generated files are stored on the server temporarily and are deleted automatically (typically within one hour). We do not keep a permanent archive of your documents or identity data." },
            { h: "6. Security", p: "The connection to the Service is protected by HTTPS (SSL). Access to the server infrastructure is restricted. We apply reasonable organisational and technical measures to prevent unauthorised access, loss or disclosure." },
            { h: "7. Cookies", p: "The Service does not use advertising or analytics cookies and does not send data to third-party tracking systems. Only technical mechanisms required for the website to function may be used." },
            { h: "8. Your rights", p: "You may stop using the Service at any time and refrain from uploading documents. Because files are not retained long-term, no lasting user profile database is maintained." },
            { h: "9. Changes", p: "We may update this Policy. The current version is always published on this page." }
        ],
        termsSections: [
            { h: "1. Acceptance", p: "These Terms of Use govern access to the EU SIGNATURE service (eusignature.com). By using the website and the document-signing function, you agree to these Terms and the Privacy Policy." },
            { h: "2. Service description", p: "The Service allows you to upload a PDF, enter client details and receive a file with an electronic seal. The Service is provided via the web interface on an “as is” basis." },
            { h: "3. User obligations", p: "You confirm that you have a lawful right to upload the document and the data you enter; that the data is accurate; and that your use of the Service does not violate applicable law. You are responsible for the content of uploaded files." },
            { h: "4. Data confidentiality", p: "The Service does not transfer uploaded documents or entered personal data to third parties. Processing is performed only to provide the signing service, as described in the Privacy Policy." },
            { h: "5. Availability", p: "We aim to keep the Service available, but we do not guarantee uninterrupted access, absence of technical faults, or compatibility with every device and browser." },
            { h: "6. Limitation of liability", p: "The Service is provided without additional warranties beyond those stated in the interface. To the maximum extent permitted by law, the operator is not liable for losses arising from unlawful use, incorrect data, user actions or circumstances beyond our control." },
            { h: "7. Prohibited use", p: "You may not use the Service for unlawful purposes, interfere with the infrastructure, attempt unauthorised access, or upload malicious files." },
            { h: "8. Changes to the Terms", p: "The operator may update these Terms. Continued use of the Service after a new version is published constitutes acceptance." },
            { h: "9. Governing law", p: "These Terms are governed by the law of the European Union and applicable national law to the extent that follows from the nature of the service and the user’s location." }
        ]
    },
    DE: {
        title: "EU SIGNATURE - Amtliche Signatur",
        subtitle: "Dienst zur sofortigen amtlichen Beglaubigung von Dokumenten mit elektronischer Signatur gemäß EU-Richtlinien.",
        docData: "Dokumentendaten",
        countryLabel: "BESCHÄFTIGUNGSLAND",
        countryCz: "Tschechische Rep.",
        countryDe: "Deutschland",
        contractLabel: "PERSONALCODE",
        clientLabel: "NAME DES KUNDEN",
        namePlaceholder: "Max Mustermann",
        passportLabel: "REISEPASSNUMMER",
        uploadLabel: "ARBEITSVERTRAG",
        uploadPlaceholder: "Vertragsdatei hochladen (.pdf)",
        uploadDrag: "Hierher ziehen oder klicken",
        removeFile: "Datei entfernen",
        downloadSuccess: "Dokument erfolgreich signiert und heruntergeladen.",
        signButton: "UNTERSCHREIBEN",
        downloadButton: "DOKUMENT HERUNTERLADEN",
        previewTitle: "UNTERSCHRIFTSVORSCHAU",
        statusLabel: "Status",
        statusReady: "BEREIT ZUM SIGNIEREN",
        infoTitle: "Rechtsgültigkeit",
        infoText: "Diese digitale Signatur wird in voller Übereinstimmung mit der Verordnung (EU) Nr. 910/2014 (eIDAS) erstellt. Sie ist rechtsgültig, wird von allen EU-Mitgliedstaaten anerkannt und gewährleistet die Integrität des unterzeichneten Dokuments.",
        footerRights: "© 2026 EU Signature Gateway. Alle Rechte vorbehalten.",
        footerPrivacy: "Datenschutzerklärung",
        footerTerms: "Nutzungsbedingungen",
        requiredFields: "* Alle Felder sind Pflichtfelder",
        badges: ["eIDAS-konform", "GDPR-sicher", "SSL-Verschlüsselung", "ISO 27001"],
        systemOnline: "SYSTEM ONLINE",
        processingPrefix: "Internationale Bearbeitung",
        livePreview: "LIVE-VORSCHAU",
        generating: "Wird erstellt…",
        processing: "VERARBEITUNG…",
        regionLabel: "Region",
        fillAllFields: "Bitte alle Felder ausfüllen",
        stampError: "Fehler beim Signieren der PDF",
        backHome: "← Zur Startseite",
        privacyUpdated: "Gültig ab: 29. August 2026",
        termsUpdated: "Gültig ab: 29. August 2026",
        privacySections: [
            { h: "1. Allgemeines", p: "Diese Datenschutzerklärung beschreibt, wie der Dienst EU SIGNATURE (eusignature.com, der „Dienst“) Daten bei der Beglaubigung von Dokumenten verarbeitet. Mit der Nutzung bestätigen Sie, dass Sie diese Erklärung gelesen haben." },
            { h: "2. Keine Weitergabe an Dritte", p: "Wir verkaufen, vermieten oder übermitteln Ihre personenbezogenen Daten nicht an Dritte, Werbenetzwerke, Analyseplattformen, Partner oder sonstige Organisationen. Daten verlassen die Infrastruktur des Dienstes nicht." },
            { h: "3. Welche Daten verarbeitet werden", p: "Zur Erstellung des Siegels verarbeitet der Dienst nur die Angaben, die Sie selbst eingeben oder hochladen: Name, Reisepassnummer, Personalcode, gewähltes Beschäftigungsland und die PDF-Datei. Technische Daten (IP-Adresse, Zeitpunkt, Browsertyp) können ausschließlich zur Betriebssicherheit protokolliert werden." },
            { h: "4. Zweck der Verarbeitung", p: "Die Daten werden ausschließlich zur Erzeugung des elektronischen Siegels, zur Bereitstellung der signierten Datei und zur Vorschau verwendet. Es gibt keinen anderen Verarbeitungszweck." },
            { h: "5. Speicherung und Löschung", p: "Hochgeladene PDFs und erzeugte Dateien werden auf dem Server nur vorübergehend gespeichert und automatisch gelöscht (in der Regel innerhalb einer Stunde). Ein dauerhaftes Archiv Ihrer Dokumente oder Ausweisdaten führen wir nicht." },
            { h: "6. Sicherheit", p: "Die Verbindung zum Dienst ist durch HTTPS (SSL) geschützt. Der Zugriff auf die Serverinfrastruktur ist beschränkt. Wir treffen angemessene organisatorische und technische Maßnahmen gegen unbefugten Zugriff, Verlust oder Offenlegung." },
            { h: "7. Cookies", p: "Der Dienst verwendet keine Werbe- oder Analyse-Cookies und übermittelt keine Daten an Tracking-Systeme Dritter. Es können lediglich technisch notwendige Mechanismen zum Betrieb der Website eingesetzt werden." },
            { h: "8. Ihre Rechte", p: "Sie können die Nutzung des Dienstes jederzeit beenden und keine Dokumente hochladen. Da Dateien nicht dauerhaft gespeichert werden, wird keine langfristige Nutzerprofildatenbank geführt." },
            { h: "9. Änderungen", p: "Wir können diese Erklärung aktualisieren. Die jeweils geltende Fassung wird auf dieser Seite veröffentlicht." }
        ],
        termsSections: [
            { h: "1. Annahme der Bedingungen", p: "Diese Nutzungsbedingungen regeln den Zugang zum Dienst EU SIGNATURE (eusignature.com). Mit der Nutzung der Website und der Signaturfunktion stimmen Sie diesen Bedingungen und der Datenschutzerklärung zu." },
            { h: "2. Leistungsbeschreibung", p: "Der Dienst ermöglicht das Hochladen einer PDF-Datei, die Eingabe von Kundendaten und die Erstellung einer Datei mit elektronischem Siegel. Der Dienst wird über die Weboberfläche „wie besehen“ bereitgestellt." },
            { h: "3. Pflichten des Nutzers", p: "Sie bestätigen, dass Sie berechtigt sind, das Dokument und die eingegebenen Daten zu verwenden, dass die Angaben zutreffen und dass die Nutzung nicht gegen geltendes Recht verstößt. Sie sind für den Inhalt hochgeladener Dateien verantwortlich." },
            { h: "4. Vertraulichkeit der Daten", p: "Der Dienst übermittelt hochgeladene Dokumente und eingegebene personenbezogene Daten nicht an Dritte. Die Verarbeitung erfolgt nur zur Erbringung der Signaturleistung gemäß der Datenschutzerklärung." },
            { h: "5. Verfügbarkeit", p: "Wir bemühen uns um einen störungsfreien Betrieb, garantieren jedoch keine ununterbrochene Verfügbarkeit, Fehlerfreiheit oder Kompatibilität mit allen Geräten und Browsern." },
            { h: "6. Haftungsbeschränkung", p: "Der Dienst wird ohne zusätzliche Garantien bereitgestellt, soweit nicht im Interface ausdrücklich angegeben. Soweit gesetzlich zulässig, haftet der Betreiber nicht für Schäden aus rechtswidriger Nutzung, fehlerhaften Daten, Handlungen des Nutzers oder Umständen außerhalb unseres Einflusses." },
            { h: "7. Unzulässige Nutzung", p: "Es ist untersagt, den Dienst für rechtswidrige Zwecke zu nutzen, in die Infrastruktur einzugreifen, unbefugten Zugang zu erlangen oder schädliche Dateien hochzuladen." },
            { h: "8. Änderungen", p: "Der Betreiber kann diese Bedingungen aktualisieren. Die weitere Nutzung nach Veröffentlichung einer neuen Fassung gilt als Zustimmung." },
            { h: "9. Anwendbares Recht", p: "Es gilt das Recht der Europäischen Union sowie das anwendbare nationale Recht, soweit sich dies aus Art der Leistung und dem Standort des Nutzers ergibt." }
        ]
    },
    CS: {
        title: "EU SIGNATURE - Oficiální podpis",
        subtitle: "Služba pro okamžité úřední ověřování dokumentů elektronickým podpisem v souladu se směrnicemi EU.",
        docData: "Údaje o dokumentu",
        countryLabel: "ZEMĚ ZAMĚSTNÁNÍ",
        countryCz: "Česká republika",
        countryDe: "Německo",
        contractLabel: "OSOBNÍ KÓD",
        clientLabel: "JMÉNO KLIENTA",
        namePlaceholder: "Jan Novák",
        passportLabel: "ČÍSLO PASU",
        uploadLabel: "PRACOVNÍ SMLOUVA",
        uploadPlaceholder: "Nahrát soubor smlouvy (.pdf)",
        uploadDrag: "Přetáhněte sem nebo klikněte",
        removeFile: "Odstranit soubor",
        downloadSuccess: "Dokument úspěšně podepsán a stažen.",
        signButton: "PODEPSAT",
        downloadButton: "STÁHNOUT DOKUMENT",
        previewTitle: "NÁHLED PODPISU",
        statusLabel: "Stav",
        statusReady: "PŘIPRAVENO K PODPISU",
        infoTitle: "Právní platnost",
        infoText: "Tento digitální podpis je generován v plném souladu s nařízením (EU) č. 910/2014 (eIDAS). Má právní platnost, je uznáván všemi členskými státy EU a zaručuje integritu podepsaného dokumentu.",
        footerRights: "© 2026 EU Signature Gateway. Všechna práva vyhrazena.",
        footerPrivacy: "Ochrana osobních údajů",
        footerTerms: "Podmínky použití",
        requiredFields: "* Všechna pole jsou povinná",
        badges: ["Soulad s eIDAS", "Zabezpečení GDPR", "Šifrování SSL", "ISO 27001"],
        systemOnline: "SYSTÉM ONLINE",
        processingPrefix: "Mezinárodní zpracování",
        livePreview: "ŽIVÝ NÁHLED",
        generating: "Generování…",
        processing: "ZPRACOVÁNÍ…",
        regionLabel: "Region",
        fillAllFields: "Vyplňte všechna pole",
        stampError: "Chyba při podpisu PDF",
        backHome: "← Zpět na hlavní stránku",
        privacyUpdated: "Účinnost: 29. srpna 2026",
        termsUpdated: "Účinnost: 29. srpna 2026",
        privacySections: [
            { h: "1. Obecná ustanovení", p: "Tyto Zásady ochrany osobních údajů popisují, jak služba EU SIGNATURE (eusignature.com, dále jen „Služba“) zpracovává údaje při ověřování dokumentů. Používáním Služby potvrzujete, že jste se s těmito Zásadami seznámili." },
            { h: "2. Údaje nepředáváme třetím stranám", p: "Neprodáváme, nepronajímáme ani nepředáváme vaše osobní údaje třetím stranám, reklamním sítím, analytickým platformám, partnerům ani jiným organizacím. Údaje neopouštějí infrastrukturu Služby." },
            { h: "3. Jaké údaje zpracováváme", p: "Pro vytvoření razítka Služba zpracovává pouze údaje, které sami zadáte nebo nahrajete: jméno, číslo pasu, osobní kód, zvolenou zemi zaměstnání a soubor PDF. Technické údaje (IP adresa, čas požadavku, typ prohlížeče) mohou být zaznamenány výhradně pro provoz a bezpečnost Služby." },
            { h: "4. Účel zpracování", p: "Údaje se používají výhradně k vygenerování elektronického razítka, doručení podepsaného souboru a zobrazení náhledu. Jiný účel zpracování není." },
            { h: "5. Uložení a výmaz", p: "Nahrané PDF a vygenerované soubory jsou na serveru uloženy dočasně a automaticky se mažou (zpravidla do jedné hodiny). Trvalý archiv vašich dokumentů ani údajů z dokladů nevedeme." },
            { h: "6. Zabezpečení", p: "Spojení se Službou je chráněno protokolem HTTPS (SSL). Přístup k serverové infrastruktuře je omezen. Přijímáme přiměřená organizační a technická opatření proti neoprávněnému přístupu, ztrátě nebo zveřejnění údajů." },
            { h: "7. Soubory cookie", p: "Služba nepoužívá reklamní ani analytické cookies a nepředává údaje do sledovacích systémů třetích stran. Mohou být použity pouze technické mechanismy nutné k chodu webu." },
            { h: "8. Vaše práva", p: "Používání Služby můžete kdykoli ukončit a dokumenty nenahrávat. Protože soubory nejsou dlouhodobě uchovávány, nevedeme trvalou databázi uživatelských profilů." },
            { h: "9. Změny", p: "Tyto Zásady můžeme aktualizovat. Aktuální znění je vždy zveřejněno na této stránce." }
        ],
        termsSections: [
            { h: "1. Přijetí podmínek", p: "Tyto Podmínky použití upravují přístup ke službě EU SIGNATURE (eusignature.com). Používáním webu a funkce podpisu dokumentů vyjadřujete souhlas s těmito Podmínkami a se Zásadami ochrany osobních údajů." },
            { h: "2. Popis služby", p: "Služba umožňuje nahrát dokument PDF, zadat údaje klienta a získat soubor s elektronickým razítkem. Služba je poskytována prostřednictvím webového rozhraní v režimu „jak je“." },
            { h: "3. Povinnosti uživatele", p: "Potvrzujete, že máte oprávnění nahrát dokument a zadané údaje, že údaje jsou správné a že použití Služby neporušuje platné právo. Za obsah nahraných souborů odpovídáte vy." },
            { h: "4. Důvěrnost údajů", p: "Služba nepředává nahrané dokumenty ani zadané osobní údaje třetím stranám. Zpracování probíhá pouze za účelem poskytnutí služby podpisu, jak je popsáno v Zásadách ochrany osobních údajů." },
            { h: "5. Dostupnost", p: "Usilujeme o plynulý provoz, nezaručujeme však nepřetržitou dostupnost, absenci technických závad ani kompatibilitu se všemi zařízeními a prohlížeči." },
            { h: "6. Omezení odpovědnosti", p: "Služba je poskytována bez dalších záruk, než které jsou výslovně uvedeny v rozhraní. V maximálním rozsahu povoleném právem provozovatel neodpovídá za škody vzniklé protiprávním užitím, nesprávnými údaji, jednáním uživatele nebo okolnostmi mimo naši kontrolu." },
            { h: "7. Zakázané užití", p: "Je zakázáno používat Službu k protiprávním účelům, zasahovat do infrastruktury, pokoušet se o neoprávněný přístup nebo nahrávat škodlivé soubory." },
            { h: "8. Změny podmínek", p: "Provozovatel může Podmínky aktualizovat. Pokračování v užívání Služby po zveřejnění nové verze znamená souhlas s ní." },
            { h: "9. Rozhodné právo", p: "Tyto Podmínky se řídí právem Evropské unie a použitelným vnitrostátním právem v rozsahu, který vyplývá z povahy služby a umístění uživatele." }
        ]
    }
};

const API = ''; // Relative path for production (Nginx proxies /api)

function getPageFromPath() {
    const path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
    if (path === '/privacy') return 'privacy';
    if (path === '/terms') return 'terms';
    return 'home';
}

function App() {
    const [lang, setLang] = useState('RU');
    const t = TRANSLATIONS[lang];
    const [page, setPage] = useState(getPageFromPath);

    const [contractNumber, setContractNumber] = useState('');
    const [clientName, setClientName] = useState('');
    const [passportNumber, setPassportNumber] = useState('');
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [country, setCountry] = useState('CZ');

    useEffect(() => {
        const onPop = () => setPage(getPageFromPath());
        window.addEventListener('popstate', onPop);
        return () => window.removeEventListener('popstate', onPop);
    }, []);

    const go = (path) => {
        window.history.pushState({}, '', path);
        setPage(getPageFromPath());
        window.scrollTo(0, 0);
    };

    // Load preview when data changes
    useEffect(() => {
        const fetchPreview = async () => {
            try {
                const res = await axios.post(`${API}/api/preview/client`, {
                    clientName,
                    passportNumber,
                    contractNumber,
                    country
                }, { responseType: 'blob' });
                const url = URL.createObjectURL(res.data);
                setPreviewUrl(url);
            } catch (err) {
                console.error("Preview error", err);
            }
        };
        const timer = setTimeout(fetchPreview, 500);
        return () => clearTimeout(timer);
    }, [clientName, passportNumber, contractNumber, country]);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setSuccess(false);
        setDownloadUrl(null);
    };

    const handleSubmit = async () => {
        if (!file || !contractNumber || !clientName || !passportNumber) {
            alert(t.fillAllFields);
            return;
        }
        setLoading(true);
        const fd = new FormData();
        fd.append('pdf', file);
        fd.append('clientName', clientName);
        fd.append('passportNumber', passportNumber);
        fd.append('contractNumber', contractNumber);
        fd.append('country', country);

        try {
            // Updated to JSON (Android Friendly) and Server-Side 'Attachment' Header (Safari Friendly)
            const res = await axios.post(`${API}/api/stamp`, fd); // EXPECT JSON: { url: '...' }

            const serverUrl = res.data.url;
            setDownloadUrl(serverUrl);
            setSuccess(true);

            // Trigger auto-download via Link Click
            const link = document.createElement('a');
            link.href = serverUrl;
            // The server sets 'Content-Type: application/octet-stream', 
            // so the browser is FORCED to download, not open.
            link.click();
            link.remove();
        } catch (err) {
            alert(t.stampError);
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="App">
            {/* HEADER */}
            <header className="App-header">
                <div className="header-content">
                    <div className="logo-section">
                        <a
                            href="/"
                            className="logo-link"
                            onClick={(e) => { e.preventDefault(); go('/'); }}
                        >
                            <img
                                src="/eu-signature-logo.png"
                                alt="EU SIGNATURE — Official EU Gateway"
                                className="site-logo"
                            />
                        </a>
                    </div>
                    <div className="header-right">
                        <div className="status-indicator">
                            <span className="dot"></span> {t.systemOnline}
                        </div>
                        {/* LANGUAGE SWITCHER */}
                        <div className="lang-switcher">
                            {['CS', 'DE', 'RU', 'EN'].map((l) => (
                                <button
                                    key={l}
                                    className={`lang-btn ${lang === l ? 'active' : ''}`}
                                    onClick={() => setLang(l)}
                                >
                                    {l}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </header>

            <main className="App-main">
                {page !== 'home' ? (
                    <article className="legal-page">
                        <button type="button" className="legal-back" onClick={() => go('/')}>
                            {t.backHome}
                        </button>
                        <h2>{page === 'privacy' ? t.footerPrivacy : t.footerTerms}</h2>
                        <p className="legal-updated">
                            {page === 'privacy' ? t.privacyUpdated : t.termsUpdated}
                        </p>
                        {(page === 'privacy' ? t.privacySections : t.termsSections).map((section) => (
                            <section key={section.h} className="legal-section">
                                <h3>{section.h}</h3>
                                <p>{section.p}</p>
                            </section>
                        ))}
                    </article>
                ) : (
                    <>
                <div className="hero-section">
                    <h2>{t.title}</h2>
                    <p>{t.subtitle}</p>
                    <div className="eu-badge-top">
                        <span>🇪🇺 {t.processingPrefix}: {country === 'CZ' ? t.countryCz : t.countryDe}</span>
                    </div>
                </div>

                <div className="workspace">
                    {/* LEFT COLUMN: FORM */}
                    <div className="form-card">
                        <div className="card-header">
                            <span className="icon">📄</span> {t.docData}
                        </div>

                        <div className="form-body">
                            {/* COUNTRY SELECTOR */}
                            <div className="form-group">
                                <label>{t.countryLabel}</label>
                                <div className="country-selector">
                                    <div
                                        className={`country-option ${country === 'CZ' ? 'selected' : ''}`}
                                        onClick={() => setCountry('CZ')}
                                    >
                                        <div className="flag-icon">🇨🇿</div>
                                        <div className="country-info">
                                            <strong>{t.countryCz}</strong>
                                        </div>
                                    </div>
                                    <div
                                        className={`country-option ${country === 'DE' ? 'selected' : ''}`}
                                        onClick={() => setCountry('DE')}
                                    >
                                        <div className="flag-icon">🇩🇪</div>
                                        <div className="country-info">
                                            <strong>{t.countryDe}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <label>{t.contractLabel}</label>
                                <input
                                    type="text"
                                    placeholder={country === 'DE' ? '732358321' : '732358/3216'}
                                    value={contractNumber}
                                    onChange={(e) => setContractNumber(e.target.value)}
                                />
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>{t.clientLabel}</label>
                                    <input
                                        type="text"
                                        placeholder={t.namePlaceholder}
                                        value={clientName}
                                        onChange={(e) => setClientName(e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>{t.passportLabel}</label>
                                    <input
                                        type="text"
                                        placeholder="AA1234567"
                                        value={passportNumber}
                                        onChange={(e) => setPassportNumber(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label>{t.uploadLabel}</label>
                                <div className={`file-upload-zone ${file ? 'has-file' : ''}`}>
                                    {!file ? (
                                        <label htmlFor="pdf-upload" className="upload-placeholder">
                                            <div className="upload-icon">☁️</div>
                                            <strong>{t.uploadPlaceholder}</strong>
                                            <span>{t.uploadDrag}</span>
                                        </label>
                                    ) : (
                                        <div className="file-preview">
                                            <span className="file-icon">📄</span>
                                            <div className="file-info">
                                                <strong>{file.name}</strong>
                                                <span>{(file.size / 1024 / 1024).toFixed(2)} MB</span>
                                            </div>
                                            <button className="remove-btn" onClick={() => setFile(null)}>{t.removeFile}</button>
                                        </div>
                                    )}
                                    <input
                                        id="pdf-upload"
                                        type="file"
                                        accept="application/pdf"
                                        onChange={handleFileChange}
                                        hidden
                                    />
                                </div>
                            </div>

                            {success && (
                                <div className="success-message">
                                    ✅ {t.downloadSuccess}
                                </div>
                            )}
                        </div>

                        <div className="form-footer">
                            <p className="disclaimer">{t.requiredFields}</p>
                            {success ? (
                                <a
                                    href={downloadUrl}
                                    className="submit-btn success-btn"
                                    download
                                    style={{ justifyContent: 'center', textDecoration: 'none', width: '100%' }}
                                >
                                    ✅ {t.downloadButton}
                                </a>
                            ) : (
                                <button
                                    className="submit-btn"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? t.processing : (
                                        <>
                                            {t.signButton} <span className="arrow">→</span>
                                        </>
                                    )}
                                </button>
                            )}
                        </div>
                    </div>

                    {/* RIGHT COLUMN: PREVIEW */}
                    <div className="preview-column">
                        <div className="stamp-preview-card">
                            <div className="preview-header">
                                <span>{t.previewTitle} {country}</span>
                                <span className="live-tag">{t.livePreview}</span>
                            </div>
                            <div className="preview-body">
                                {previewUrl ? (
                                    <img src={previewUrl} alt="Stamp Preview" className="stamp-img" />
                                ) : (
                                    <div className="loading-preview">{t.generating}</div>
                                )}
                            </div>
                            <div className="preview-footer">
                                <div className="status">
                                    <label>{t.statusLabel}</label>
                                    <strong className="status-ok">{t.statusReady}</strong>
                                </div>
                                <div className="meta">
                                    <label>{t.regionLabel}</label>
                                    <strong>{country === 'CZ' ? t.countryCz : t.countryDe}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                        <div className="info-box">
                            <div className="info-icon">⚖️</div>
                            <div className="info-content">
                                <h4>{t.infoTitle}</h4>
                                <p>{t.infoText}</p>
                            </div>
                        </div>
                    </>
                )}
            </main>

            {/* FOOTER */}
            <footer className="App-footer">
                <div className="footer-content">
                    <div className="footer-links">
                        <span>{t.footerRights}</span>
                        <a href="/privacy" onClick={(e) => { e.preventDefault(); go('/privacy'); }}>{t.footerPrivacy}</a>
                        <a href="/terms" onClick={(e) => { e.preventDefault(); go('/terms'); }}>{t.footerTerms}</a>
                    </div>
                    <p className="footer-compliance">{t.badges.join(' · ')}</p>
                </div>
            </footer>
        </div>
    );
}

export default App;
